import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

function nextDays(n) {
  const out = [];
  const wd = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  for (let i = 0; i < n; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    out.push({ wd: wd[d.getDay()], day: d.getDate(), iso: d.toISOString().split('T')[0] });
  }
  return out;
}

const ALL_SLOTS = ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '1:00', '1:30', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00'];

export default function AppBooking() {
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [days] = useState(nextDays(7));
  const [dateIdx, setDateIdx] = useState(0);
  const [slot, setSlot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(localStorage.getItem('userName') || '');

  useEffect(() => {
    const b = sessionStorage.getItem('app_booking');
    if (!b) { navigate('/app/home'); return; }
    setBooking(JSON.parse(b));
  }, [navigate]);

  if (!booking) return null;

  // Hide past slots for today
  const isToday = dateIdx === 0;
  const nowH = new Date().getHours();

  const confirm = async () => {
    if (!name.trim()) { toast.error('Please enter your name'); return; }
    if (!slot) { toast.error('Please select a time slot'); return; }
    setLoading(true);
    try {
      localStorage.setItem('userName', name.trim());
      const phone = localStorage.getItem('userPhone') || '';
      await axios.post(`${API}/booking/create`, {
        salon_id: booking.salon_id,
        booking_date: days[dateIdx].iso,
        slot_time: slot,
        customer_phone: phone,
        customer_name: name.trim(),
        salon_name: booking.salon_name,
        services: booking.services,
        total_amount: booking.total,
      }, { timeout: 12000 });

      // Build WhatsApp confirmation
      const salonPhone = String(booking.salon_phone || '').replace(/\D/g, '');
      const waNum = salonPhone.length === 10 ? `91${salonPhone}` : salonPhone;
      const waText = encodeURIComponent(
        `Namaste! Booking ki hai BookYourSalons se.\nSalon: ${booking.salon_name}\nServices: ${booking.services.map(s => s.name).join(', ')}\nDate: ${days[dateIdx].iso}\nTime: ${slot}\nTotal: ₹${booking.total}`
      );
      sessionStorage.setItem('app_done', JSON.stringify({
        salon_name: booking.salon_name, date: days[dateIdx].iso, slot, total: booking.total,
        wa: waNum ? `https://wa.me/${waNum}?text=${waText}` : '',
      }));
      navigate('/app/done');
    } catch (e) {
      const msg = e?.response?.data?.message || 'Booking nahi ho payi. Dobara try karein.';
      toast.error(msg);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '18px 16px', display: 'flex', alignItems: 'center', gap: 14, position: 'sticky', top: 0, zIndex: 10 }}>
        <span onClick={() => navigate(-1)} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Select date & time</div>
          <div style={{ fontSize: 12, opacity: 0.85 }}>{booking.salon_name}</div>
        </div>
      </div>

      <div style={{ padding: 16 }}>
        <h3 style={{ fontSize: 16, fontWeight: 800, color: INK, marginBottom: 12 }}>Your Name</h3>
        <input value={name} onChange={e => setName(e.target.value)} placeholder="Enter your name"
          style={{ width: '100%', background: '#fff', border: '1.5px solid #f0f0f4', borderRadius: 12, padding: '14px 16px', fontSize: 15, color: INK, outline: 'none', marginBottom: 20, boxSizing: 'border-box' }} />

        <h3 style={{ fontSize: 16, fontWeight: 800, color: INK, marginBottom: 12 }}>Choose date</h3>
        <div style={{ display: 'flex', gap: 10, overflowX: 'auto', marginBottom: 20 }}>
          {days.map((d, i) => (
            <div key={i} onClick={() => { setDateIdx(i); setSlot(null); }} style={{ flex: '0 0 auto', background: '#fff', border: dateIdx === i ? `1.5px solid ${RED}` : '1.5px solid #f0f0f4', borderRadius: 14, padding: '11px 16px', textAlign: 'center', cursor: 'pointer', minWidth: 60, background: dateIdx === i ? '#fdf2f5' : '#fff' }}>
              <div style={{ fontSize: 11, color: GREY }}>{d.wd}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: dateIdx === i ? RED : INK, marginTop: 2 }}>{d.day}</div>
            </div>
          ))}
        </div>

        <h3 style={{ fontSize: 16, fontWeight: 800, color: INK, marginBottom: 12 }}>Choose time</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
          {ALL_SLOTS.map((s, i) => {
            const hour = parseInt(s);
            const past = isToday && hour < nowH && hour > 7; // rough past check for morning slots
            return (
              <div key={i} onClick={() => !past && setSlot(s)} style={{ background: slot === s ? '#fdf2f5' : '#fff', border: slot === s ? `1.5px solid ${RED}` : '1.5px solid #f0f0f4', borderRadius: 12, padding: '13px 6px', textAlign: 'center', fontSize: 13, fontWeight: 600, color: past ? '#ccc' : (slot === s ? RED : INK), cursor: past ? 'default' : 'pointer', textDecoration: past ? 'line-through' : 'none', opacity: past ? 0.4 : 1 }}>{s}</div>
            );
          })}
        </div>

        <div style={{ background: '#fff', borderRadius: 14, padding: 16, marginTop: 22, boxShadow: '0 2px 10px rgba(28,28,40,.05)' }}>
          {booking.services.map((s, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: GREY, marginBottom: 8 }}><span>{s.name}</span><span>₹{s.price}</span></div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, fontWeight: 800, color: INK, borderTop: '1px solid #f0f0f4', paddingTop: 10 }}><span>Total</span><span style={{ color: RED }}>₹{booking.total}</span></div>
        </div>

        <button onClick={confirm} disabled={loading} style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', border: 'none', borderRadius: 14, padding: 16, fontSize: 16, fontWeight: 700, width: '100%', marginTop: 18, cursor: 'pointer', boxShadow: '0 8px 20px rgba(185,29,71,.3)', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Booking...' : 'Confirm Booking'}
        </button>
      </div>
    </div>
  );
}
